export const LABELS = {
  HEADER_TITLE: "{0}登録",
  CREDIT_CARD_MERCHANT_NUMBERS: "クレカ加盟店番号",
  ORDER_TARGET_NAME: "クレカ審査依頼先",
  SHOP_IDS: "ShopID情報",
  ERROR_TITLE: "ID払い出し結果受領・取込エラー内容",
  CREDIT_CARD_TEXT_AREA_PLACE_HOLDER:
    "クレカ加盟店番号は改行で区切って入力してください。\n例\n123456\n234567\n111111",
  SHOP_ID_TEXT_AREA_PLACE_HOLDER:
    "ShopIDとSPIDの間は半角スペース、カンマ、タブのいずれかを入力してください。\nまた、ShopID情報は改行で区切って入力してください。\n例\n123456 234567\n111111,222222\n77777  88888",
} as const;

export const CONFIGS = {
  SHOP_IDS: "shop-ids",
  CREDIT_CARD_MERCHANT_NUMBERS: "credit-card-merchant-numbers",
  QUERY_PARAMETER_ORDER_TARGET_CODE: "orderTargetCode",
  ID_LIST: "idList",
  SELECT_ITEM: "selectItem",
  LF_CODE: /\r\n|\n|\r/g,
} as const;
